<template>
  <div>
    <el-drawer
      id="c8284a"
      title=""
      :visible.sync="newDialog"
      :with-header="false"
      direction="ltr"
      @close="closeDialog"
      :append-to-body="true"
      custom-class="slider-menu-wrap"
    >
      <div id="c5aa52" class="menu_layout_box">
        <div id="g9c54a">
          <div class="menu-icon" @click="closeDialog">
            <div class="menu-round-con" v-for="item in 3" :key="item">
              <div class="menu-round-item"></div>
              <div class="menu-round-item"></div>
              <div class="menu-round-item"></div>
            </div>
          </div>
        </div>
        <div id="ga563c" class="menu_layout_title_box margin-left10">
          <div id="g60c73" class="menu_layout_title">
            {{ $t("Home.Applications") }}
          </div>
        </div>
        <div id="g4ded7" class="menu_box margin-left10">
          <div id="gcb9c7" @click="goHome()" class="menu_box_1">
            <div class="flex_center menu_icon">
              <img
                src="../../assets/images/seachCompany.png"
                alt=""
                class="headImg"
              />
            </div>
            <div id="geda81">
              <div id="g5a801" class="menu_title">
                {{ $t("Home.SearchCompanies") }}
              </div>
            </div>
          </div>
          <div id="ce5823" class="u7d321 menu_box_1 menu_box_2" v-if="true">
            <div class="flex_center menu_icon">
              <img
                src="../../assets/images/SearchLeads.png"
                alt=""
                class="headImg"
              />
            </div>
            <div id="c87e85">
              <div
                id="cf3b94"
                class="uaee16 menu_title"
                @click="goPageUrl('/leads/index')"
              >
                {{ $t("Home.SearchLeads") }}
                <img
                  src="../../assets/images/betaleads.png"
                  alt=""
                  class="head_img_beta"
                />
              </div>
            </div>
          </div>
          <div id="cdac66" class="u7d321 menu_box_1" v-if="true">
            <div class="flex_center menu_icon">
              <img
                src="../../assets//images/SearchTrade.png"
                alt=""
                class="headImg"
              />
            </div>
            <div id="cfed6e" class="u2e886">
              <!-- @click="gotoOne('https://csibizsearch.com/#/?id=Search Trade&show=2')" -->
              <div
                id="c12ae8"
                class="uaee16 menu_title"
                @click="goPageUrl('/trade/index')"
              >
                {{ $t("Home.SearchTrade") }}
                <img
                  src="../../assets/images/betatrade.png"
                  alt=""
                  class="head_img_beta"
                />
              </div>
            </div>
          </div>
          <div id="c38882" class="u7d321 menu_box_1 menu_box_2" v-if="true">
            <div class="menu_icon">
              <img
                src="../../assets/images/SearchRisk.png"
                class="headImg"
                alt=""
              />
            </div>
            <div id="c7e5ec" class="u2e886">
              <div
                id="c4d0b8"
                class="uaee16 menu_title"
                @click="goPageUrl('/sanction/index?selectCode=4')"
              >
                {{ $t("Home.SearchSanctions") }}
              </div>
            </div>
          </div>
          <!-- <div id="c6d18b" class="menu_box_1" v-if="true">
          <div style="width: 50px" class="flex_center">
            <img
              src="../../assets//images//SearchCountry.png"
              alt=""
              class="headImg"
            />
          </div>
          <div id="cac2bf" class="u2e886">
            <div
              id="cbc952"
              class="menu_title"
              @click="
                gotoOne('https://csibizsearch.com/#/?id=Search Country&show=4')
              "
            >
             {{ $t('Home.SearchCountries') }}
            </div>
          </div>
        </div> -->
          <div id="cd8129" class="u7d321 menu_box_1 menu_box_2" v-if="true">
            <div class="flex_center menu_icon">
              <img
                src="../../assets/images/SearchNews.png"
                alt=""
                class="headImg"
              />
            </div>

            <div id="c86239" class="uc43d5">
              <div
                id="ce8d52"
                class="uaee16 menu_title"
                @click="goPageUrl('/news/index')"
              >
                {{ $t("Home.SearchNews") }}
              </div>
            </div>
          </div>

          <div id="ce5823" class="u7d321 menu_box_1 menu_box_2" v-if="false">
            <div class="flex_center menu_icon">
              <img
                src="../../assets/images/RisScan.png"
                alt=""
                class="headImg"
              />
            </div>
            <div id="c87e85">
              <div
                id="cf3b94"
                class="uaee16 menu_title"
                @click="reportDialog = true"
              >
                {{ $t("Home.RiskScan") }}
              </div>
            </div>
          </div>
          <div id="ce5823" class="u7d321 menu_box_1 menu_box_2" v-if="true">
            <div class="flex_center menu_icon">
              <img
                src="../../assets/images/RisScan.png"
                alt=""
                class="headImg"
              />
            </div>
            <div id="c87e85">
              <div
                id="cf3b94"
                class="uaee16 menu_title"
                @click="goPageUrl('/riskScanning/index')"
              >
                {{ $t("Home.RiskScan") }}
                <img
                  src="../../assets/images/betascan.png"
                  alt=""
                  class="head_img_beta"
                />
              </div>
            </div>
          </div>
          <div id="ce5823" class="u7d321 menu_box_1 menu_box_2" v-if="true">
            <div class="flex_center menu_icon">
              <img
                src="../../assets/images/searchUBO.png"
                alt=""
                class="headImg"
              />
            </div>
            <div id="c87e85">
              <div
                id="cf3b94"
                class="uaee16 menu_title"
                @click="goPageUrl('/UBO/index')"
              >
                {{ $t("Home.SearchRelationship") }}
                <img
                  src="../../assets/images/betaubo.png"
                  alt=""
                  class="head_img_beta"
                />
              </div>
            </div>
          </div>
          <div id="ce5823" class="u7d321 menu_box_1 menu_box_2" v-if="true">
            <div class="flex_center menu_icon">
              <img
                src="../../assets/images/DataServices.png"
                alt=""
                class="headImg"
              />
            </div>
            <div id="c87e85">
              <div
                id="cf3b94"
                class="uaee16 menu_title dataService"
                @click="goPageUrl('/dataServices/index')"
              >
                {{ $t("Home.DataServices") }}
                <img
                  src="../../assets/images/beta.svg"
                  alt=""
                  class="headImg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <riskdrawer
      :showReport="reportDialog"
      @closeReportDialog="closeRiskDialog($event)"
    ></riskdrawer>
  </div>
</template>
<script>
import riskdrawer from "../risk-drawer/riskdrawer.vue";
export default {
  name: "",

  props: {
    RouterDrawer: {
      type: Boolean,
    },
  },

  mounted() {},

  components: {
    riskdrawer,
  },

  data() {
    return {
      reportDialog: false,
      newDialogtwo: false,
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.RouterDrawer;
      },
      set() {},
    },
  },
  methods: {
    closeRiskDialog(value) {
      this.reportDialog = value;
    },
    closeDialog() {
      this.$emit("closeCloseDialog", false);
    },
    openUrl(pathUrl) {
      let keyWord =
        this.$route.query.keword == undefined ? 2 : this.$route.query.keword;

      if (pathUrl.includes("Detail")) {
        let routeData = this.$router.resolve({
          path: pathUrl,
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          path: pathUrl + "?keword=" + keyWord,
        });
        window.open(routeData.href, "_blank");
      }

      this.drawer = false;
    },
    gotoOne(value) {
      window.open(value, "_blank");
    },
    goPageUrl(path) {
      let href = window.location.origin + "#" + path;
      window.open(href, "_blank");
    },
    goHome() {
      this.$emit("closeCloseDialog", false);
      this.$router.push("/");
    },
  },
};
</script>
<style scoped>
.ufexJgR {
  margin-left: -1rem;
}
.menu_layout_title {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-top: 40px;
  margin-bottom: 26px;
  color: rgb(6, 6, 6);
  font-size: 24px;
  font-family: "Arial Bold";
}

.menu_box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.menu_box_1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  cursor: pointer;
}

.menu_title {
  padding-left: 20px;
  color: rgb(1, 1, 1);
  font-size: 18px;
}
.menu_title.dataService {
  display: flex;
  align-items: center;
  gap: 0 4px;
}
.menu_box_2 {
  display: flex;
  justify-content: flex-start;
  /* padding-left: 1.1em; */
  overflow-y: hidden;
}

.uZ6BszV {
  margin-right: 0.8rem;
}
/* 动态九宫格 */
.menu-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 28px;
  margin-right: 40px;
  cursor: pointer;
}
.menu-round-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-round-con .menu-round-item {
  width: 6px;
  height: 6px;
  background: rgb(6, 6, 6);
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}
.menu-round-item {
  /* box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5); */
}
.menu-icon:hover .menu-round-item:first-child {
  width: 100%;
  height: 4px;
}

.menu-icon:hover .menu-round-item:nth-last-child(-n + 2) {
  width: 0px;
}
.menu_icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.head_img_beta {
  width: 40px;
  vertical-align: middle;
}
@media screen and (max-width: 1920px) {
  .menu_icon {
    width: 34px;
    height: 34px;
  }
  .menu_title {
    padding-left: 15px;
    font-size: 16px;
  }
  .menu_box_1 {
    margin-bottom: 15px;
  }
  .menu_layout_title {
    margin-top: 30px;
    margin-bottom: 20px;
    font-size: 20px;
  }
}
</style>
